<template>
  <div class="dashboard">
    <navbar />

    <b-container>
      <b-row>
        <b-col>
          <h1 class="my-4">My Dashboard</h1>
        </b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col>
          <h2>Courses</h2>
        </b-col>
      </b-row>

      <b-row v-if="isLoading" class="my-5">
        <b-col>
          <b-spinner label="Loading..." variant="warning"></b-spinner>
        </b-col>
      </b-row>

      <b-row v-else class="mb-5">
        <b-col md="12">
          <b-card title="Foundation" class="mb-3">
            <b-card-text>
              Learn key concepts of programming such as variables, loops and
              conditionals by solving bitesize activities using block-based
              programming.
            </b-card-text>
            <b-progress
              :value="doneActivities.foundation.length"
              :max="8"
              class="mb-3"
            ></b-progress>
            <b-button
              class="mr-2 mb-2"
              v-for="level in foundationLevels"
              :key="level.level"
              :variant="getButtonVariant(level, 'foundation')"
              :href="'/foundation/' + level.level"
            >
              {{ level.title }}
            </b-button>
          </b-card>
        </b-col>

        <b-col md="12">
          <b-card title="Foundation Challenges" class="mb-3">
            <b-card-text>
              A comprehensive set of programming puzzles to test your core
              concepts of programming.
            </b-card-text>
            <b-progress
              :value="doneActivities.challenge.length"
              :max="33"
              class="mb-3"
            ></b-progress>
            <b-button
              class="mr-2 mb-2"
              v-for="level in foundationChallengeLevels"
              :key="level.level"
              :variant="getButtonVariant(level, 'challenge')"
              :to="'/foundation-challenges/' + level.level"
            >
              {{ level.title }}
            </b-button>
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <app-footer />
  </div>
</template>

<script>
import { mapState } from "vuex";

import AppFooter from "@/components/AppFooter.vue";
import Navbar from "@/components/Navbar.vue";

import LevelRepository from "@/repositories/level-repository";
import ChallengeLevelRepository from "@/repositories/challenges-level-repository";
import UserServices from "@/services/user-services";

export default {
  name: "Dashboard",

  components: {
    Navbar,
    AppFooter
  },

  data() {
    return {
      foundationLevels: [],
      foundationChallengeLevels: [],
      activities: [],
      doneActivities: {
        foundation: [],
        challenge: []
      },
      isLoading: true
    };
  },

  created() {
    this.getLevels();
    this.getChallengeLevels();
    this.getUserDoneActivities();
  },

  computed: {
    ...mapState(["user"])
  },

  methods: {
    getLevels() {
      this.foundationLevels = LevelRepository.getLevels();
    },

    getChallengeLevels() {
      this.foundationChallengeLevels = ChallengeLevelRepository.getLevels();
    },

    async getUserDoneActivities() {
      this.activities = await UserServices.getUserDoneActivities(
        this.user.uid
      ).catch(error => {
        alert(error.message);
      });

      this.isLoading = false;

      this.doneActivities["foundation"] = this.activities
        .filter(activity => {
          return activity.program == "foundation";
        })
        .map(activity => {
          return activity.id;
        });

      this.doneActivities["challenge"] = this.activities
        .filter(activity => {
          return activity.program == "foundation-challenges";
        })
        .map(activity => {
          return activity.id;
        });
    },

    getButtonVariant(level, program) {
      return this.doneActivities[program].includes(level.firebaseId)
        ? "primary"
        : "outline-primary";
    }
  }
};
</script>

<style></style>
